/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

'use strict';

/**
 * Asserts that the input is a matches the `RelayContext` type defined in
 * `RelayEnvironmentTypes` and returns it as that type.
 */
function assertRelayContext(relay) {
  !isRelayContext(relay) ? process.env.NODE_ENV !== 'production' ? require('fbjs/lib/invariant')(false, 'RelayContext: Expected `context.relay` to be an object conforming to ' + 'the `RelayContext` interface, got `%s`.', relay) : require('fbjs/lib/invariant')(false) : void 0;
  return relay;
}

/**
 * Determine if the input is a plain object that matches the `RelayContext`
 * type defined in `RelayEnvironmentTypes`.
 */
function isRelayContext(context) {
  return typeof context === 'object' && context !== null && !Array.isArray(context) && require('./isRelayEnvironment')(context.environment) && require('./isRelayVariables')(context.variables);
}

module.exports = {
  assertRelayContext: assertRelayContext,
  isRelayContext: isRelayContext
};


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/lib/RelayContext.js
// module id = 123
// module chunks = 3